<div *ngIf="reportType == 'AllCommReport'">
    
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="5">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <th colspan="3">दिनांक : {{ today | date:'dd/MM/yyyy' }}</th>
                    <th colspan="2">पृष्ठ क्र :-1</th>
                </tr>
                <tr>
                    <th colspan="5">अंकाचे नाव</th>
                    <!-- <th colspan="1">Date : {{today}}</th> -->
                    <th colspan="3">From - {{startDate | date:'dd/MM/yyyy' }}</th>
                    <th colspan="2">To - {{endDate | date:'dd/MM/yyyy' }}</th>
                    <!-- <th colspan="2">All Advt List</th>
                    <th colspan="1">In Details</th> -->
                </tr>
                <tr>
                    <th colspan="1">Invoice No</th>
                    <th colspan="1">Invoice Date</th>
                    <th colspan="1">Paid Comm Date</th>
                    <th colspan="1">Advt Name </th>
                    <!-- <th colspan="1">Contact No</th> -->
                    <th colspan="1">Issue Name</th>
                    <th colspan="1">Issue Date</th>
                    <th colspan="1">Net Amt</th>
                    <th colspan="1">Pending Amt</th>
                    <th colspan="1">Received Amt</th>
                    <th colspan="1">Paid Comm Amt</th>
                    <!-- <th colspan="1">Selected Amount</th> -->
                </tr>   
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
           <tbody *ngFor="let data of getpaiddata; let i = index">
    <tr>
        <td colspan="4" style="font-weight: bold; font-size: 16px;">Representative Name</td>
        <td colspan="3" style="font-weight: bold; font-size: 16px;">{{data.rep_name}} </td>
        <td colspan="3" style="font-weight: bold; font-size: 16px;"></td>
    </tr>

    <ng-container *ngFor="let data1 of data.rep_data; let j = index">
        <tr>
            <td colspan="1">{{data1.advt_invoice_no}}</td>
            <td colspan="1">{{data1.advt_invoice_date}}</td>
            <td colspan="1">{{data1.com_paid_date}}</td>
            <td colspan="1" style="text-align:left;">{{data1.advt_name}}</td>
            <td colspan="1" style="text-align:left;">{{data1.DS_ISSUENAME}}</td>
            <td colspan="1">{{data1.DS_ISSUEDATE}}</td>
            <td colspan="1" style="text-align: right;">{{(data1.net_amount* 1).toFixed(2)}}</td>
            <td colspan="1" style="text-align: right;">{{(data1.pending_amt * 1).toFixed(2)}}</td>
            <td colspan="1" style="text-align: right;">{{(data1.rcv_amt * 1).toFixed(2)}}</td>
            <td colspan="1" style="text-align: right;">{{(data1.com_amt * 1).toFixed(2)}}</td>
            <!-- <td colspan="1">{{data1.credit_amt}}</td> -->
        </tr>
    </ng-container>

    <tr>
        <td colspan="6" style="font-weight: bold;font-size: 16px;">Total:</td>
        <td colspan="1" style="font-weight: bold;font-size: 16px;text-align: right;">{{(data.net_total * 1).toFixed(2)}}</td>
        <td colspan="1" style="font-weight: bold;font-size: 16px;text-align: right;">{{(data.pending_total* 1).toFixed(2)}}</td>
        <td colspan="1" style="font-weight: bold;font-size: 16px;text-align: right;">{{(data.rcv_amt * 1).toFixed(2)}}</td>
        <td colspan="1" style="font-weight: bold;font-size: 16px;text-align: right;">{{(data.com_amt * 1).toFixed(2)}}</td>
        <!-- <td colspan="1" style="font-weight: bold;font-size: 16px;"></td> -->
        <!-- <td colspan="1" style="font-weight: bold;font-size: 16px;"></td> -->
        <!-- <td colspan="1" style="font-weight: bold;font-size: 16px;"></td> -->
    </tr>
</tbody>


            <tfoot>
             
              
              </tfoot>  
        </table>
       
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
           
            <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
                (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
                Export
            </button>

            <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
        [useExistingCss]="true"
        (click)="printPage3()">
            Print
        </button>
            
            <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
                Close
            </button>
        </div>
</div>